import { SectionHeader } from "@/components/SectionHeader";
const CAPABILITIES = [
  {
    title: "Lighting Control",
    detail: "Dimming · Scenes · Scheduling · Occupancy response",
  },
  {
    title: "Energy Management",
    detail: "Occupancy optimization · Scheduling · Energy monitoring",
  },
  {
    title: "Guest Room Controls",
    detail: "Lighting · Climate · Occupancy · Room status · Scheduling",
  },
  {
    title: "Climate Control",
    detail: "HVAC · Temperature · Humidity · Occupancy",
  },
  {
    title: "Property Monitoring",
    detail: "Water · Smoke · Noise · Equipment · Environmental conditions",
  },
  {
    title: "Operations & Automation",
    detail: "Alerts · Automated workflows · Remote management · Provisioning",
  },
];

export function ValuePropsSection() {
  return (
    <section className="px-4 py-20 md:px-6 md:py-16">
      <div className="mx-auto flex max-w-6xl flex-col gap-12">
        <SectionHeader
          variant="centered"
          mobileAlign="start"
          className="px-4 md:px-0"
          eyebrow="Capabilities"
          title="Everything Somo makes possible"
        />
        <ul className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {CAPABILITIES.map((capability) => (
            <li
              key={capability.title}
              className="flex flex-col gap-4 rounded-card border border-primary p-6 md:p-10"
            >
              <h3 className="text-balance text-lg leading-title text-primary md:text-2xl md:leading-tight">
                {capability.title}
              </h3>
              <p className="text-sm leading-normal tracking-body text-secondary md:text-base">
                {capability.detail}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
